import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {InvoiceFileState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class InvoiceFileQuery extends QueryEntity<InvoiceFileState> {

  constructor(protected store: Store) {
    super(store);
  }

}
